import {
  GetEvaluationCriteriaQuery,
  RoleplayQuery,
  RoleplaySessionQuery,
  VisibilityScope,
  ProgramRoleplayScenariosAnalyticsQuery,
  MyCollectionsQuery,
  PaginatedRoleplaysQuery,
  ScenarioQuery,
  ScenariosListQuery,
  ProgramComponentQuery,
} from "@/graphql";
import { NonNullableArrayItem } from "@/utils/types";

import { FilterOption } from "./filter";

// ================================
// Views/Filters
// ================================

export type RoleplayViewMode = "list" | "column";
export type RoleplayView = "details" | "scenarios" | "settings";
export type Scope = VisibilityScope | "All";
export type ScenariosPageType = "assigned" | "personal" | "all";

export type RoleplayPage =
  | "roleplayDetail"
  | "scenarioDetail"
  | "sessionDetail"
  | "scenarioCreate"
  | "intakeProcessing"
  | "scenarioEdit";

export interface ScopeFilterOption extends FilterOption {
  id: Scope;
  name: string;
}

export const SCOPE_FILTER_OPTIONS: ScopeFilterOption[] = [
  {
    id: "All",
    name: "All",
  },
  {
    id: VisibilityScope.User,
    name: "Personal",
  },
  {
    id: VisibilityScope.Workspace,
    name: "Workspace",
  },
  {
    id: VisibilityScope.Global,
    name: "Global",
  },
];

// ================================
// Modals/Dialogs
// ================================

export type ScenarioModal =
  | "editCharacter"
  | "deleteScenario"
  | "cloneScenario"
  | "addToCollection"
  | "editScenario";

export type RoleplayModal =
  | "editCollection"
  | "deleteRoleplay"
  | "cloneCollection";

export type EvaluationCriteriaDialog =
  | "remove-criterion"
  | "edit-criterion"
  | "add-criterion"
  | "sort-criteria"
  | "import-from-collection"
  | "confirm-remove-all-criteria";

// ================================
// Roleplays
// ================================

export type CollectionsRoleplay = NonNullableArrayItem<
  NonNullable<MyCollectionsQuery["myCollections"]>
>;

export type FullRoleplay = NonNullable<RoleplayQuery["roleplay"]>;

export type PaginatedRoleplay = NonNullableArrayItem<
  NonNullable<PaginatedRoleplaysQuery["paginatedRoleplays"]>["data"]
>;

// ================================
// Roleplay Sessions
// ================================

export type FullRoleplaySession = NonNullable<
  RoleplaySessionQuery["roleplaySession"]
>;

export type AnalyticsRoleplaySession = NonNullableArrayItem<
  NonNullableArrayItem<
    ProgramRoleplayScenariosAnalyticsQuery["programRoleplayScenariosAnalytics"]
  >["roleplaySessions"]
>;

// ================================e
// Scenarios
// ================================

export type AnalyticsScenario = NonNullableArrayItem<
  ProgramRoleplayScenariosAnalyticsQuery["programRoleplayScenariosAnalytics"]
>;

export type FullScenario = NonNullable<ScenarioQuery["scenario"]>;

export type ListScenario = NonNullableArrayItem<
  NonNullable<ScenariosListQuery["scenarios"]>["data"]
>;

export type RoleplayScenario = NonNullableArrayItem<
  NonNullable<FullRoleplay["scenarios"]>
>;

export type ProgramScenario = NonNullableArrayItem<
  NonNullable<ProgramComponentQuery["programComponent"]>["roleplayScenarios"]
>;

// ================================
// Evaluation Criterion
// ================================

export type EvaluationCriterionItem = NonNullableArrayItem<
  NonNullableArrayItem<
    NonNullable<GetEvaluationCriteriaQuery["evaluationCriteria"]>
  >["items"]
>;

export type EvaluationCriteria = NonNullableArrayItem<
  NonNullable<GetEvaluationCriteriaQuery["evaluationCriteria"]>
> & {
  items?: (EvaluationCriterionItem | null)[] | null;
};
